export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7549.9092ddf8.jpg";